import { css } from "@styled-system/css";

export const actionsClass = css({ display: "flex", gap: "2" });

export const badgeCompatibleClass = css({ color: "success.100" });
export const badgeIncompatibleClass = css({ color: "error.100" });
